module.exports = __webpack_public_path__ + "img/TV.5af9b7b0.svg";